interface CsrfPayload {
  csrf_token?: string;
  csrf_hash?: string;
}

interface CsrfWindow extends Window {
  sec_token?: string;
  sec_token_name?: string;
}

const csrfEndpoint = "/phone/api/csrf/";

let pendingRequest: Promise<void> | null = null;

/**
 * Names and fills every CSRF placeholder on the page.
 */
export function applyCsrf(data: CsrfPayload): void {
  const hash = data.csrf_hash;

  if (!hash) {
    return;
  }

  const csrfWindow = window as CsrfWindow;
  const tokenName = data.csrf_token || csrfWindow.sec_token_name || "";

  document
    .querySelectorAll<HTMLInputElement>("[data-csrf-field]")
    .forEach((field) => {
      field.name = tokenName;
      field.value = hash;
    });

  csrfWindow.sec_token_name = tokenName;
  csrfWindow.sec_token = hash;
}

/**
 * Loads a token once per page, since pages served from the CDN are shared by
 * every visitor and cannot carry one of their own. Call this before any POST
 * the CSRF filter will check.
 */
export function ensureCsrf(): Promise<void> {
  if ((window as CsrfWindow).sec_token) {
    return Promise.resolve();
  }

  if (pendingRequest) {
    return pendingRequest;
  }

  pendingRequest = fetch(csrfEndpoint, {
    credentials: "same-origin",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((data: CsrfPayload | null) => {
      pendingRequest = null;

      if (data) {
        applyCsrf(data);
      }
    })
    .catch(() => {
      // Leave the placeholder empty so the next attempt retries the fetch.
      pendingRequest = null;
    });

  return pendingRequest;
}
